
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const place_order = createAsyncThunk(
    'order/place_order',
    async ({
        price,
        products,
        shipping_fee,
        shippingInfo,
        userId,
        navigate,
        items,
        
    }, { }) => {
        try {
            const {
                data
            } = await api.post('/home/order/palce-order', {
                price,
                products,
                shipping_fee,
                shippingInfo,
                userId,
                navigate,
                items,
                
            })
            navigate('/payment', {
                state: {
                    price: price,
                    items,
                    orderId: data.orderId
                }
            })
            console.log(data)
            return data
        } catch (error) {
            console.log(error.response)
        }
    }
)

export const get_orders = createAsyncThunk(
    'order/get_orders',
    async ({
        customerId,
        status
    }, {
        rejectWithValue,
        fulfillWithValue,
    }) => {
        try {
            const {
                data
            } = await api.get(`/home/customer/gat-orders/${customerId}/${status}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Orders alına bilmədi' }
            )
        }
    }
)

// ✅ Rəsmi (adminDigitalOrder) sifarişləri — yalnız öz sifarişləri (backend req.customerId)
export const get_my_digital_orders = createAsyncThunk(
    'order/get_my_digital_orders',
    async (customerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/digital-orders/${customerId}`)
            return fulfillWithValue(data)   // { orders }
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Rəsmi sifarişlər alına bilmədi' })
        }
    }
)

// ✅ YENİ - Get Seller Orders
export const get_seller_orders = createAsyncThunk(
    'order/get_seller_orders',
    async ({ sellerId, page, parPage, searchValue }, {
        rejectWithValue,
        fulfillWithValue,
    }) => {
        try {
            const {
                data
            } = await api.get(`/seller/orders/${sellerId}?page=${page}&parPage=${parPage}&searchValue=${searchValue}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Seller orders alına bilmədi' }
            )
        }
    }
)

export const get_order = createAsyncThunk(
    'order/get_order',
    async (orderId, {
        rejectWithValue,
        fulfillWithValue,
    }) => {
        console.log('🔍 Fetching order:', orderId)
        
        try {
            let order = null
            
            
            // First try normal order
            try {
                const response = await api.get(`/home/customer/gat-order/${orderId}`)
                console.log('📦 Normal order response:', response.data)
                
                // Handle different response formats
                order = response.data.order || response.data
                
                if (order && order._id) {
                    console.log('✅ Found normal order:', order._id)
                    return fulfillWithValue({ order, isDigital: false })
                }
            } catch (normalError) {
                console.log('⚠️ Not a normal order, trying digital...')
            }
            
            // If not found or invalid, try digital order
            try {
                const digitalResponse = await api.get(`/home/customer/digital-order/${orderId}`)
                console.log('🎮 Digital order response:', digitalResponse.data)
                
                // Handle different response formats
                order = digitalResponse.data.order || digitalResponse.data
                
                
                if (order && (order._id || order.orderId)) {
                    console.log('✅ Found digital order:', order._id || order.orderId)
                    return fulfillWithValue({ order, isDigital: true })
                }
            } catch (digitalError) {
                console.error('❌ Digital order error:', digitalError.response?.data)
            }
            
            // If still no order found
            console.error('❌ Order not found in both collections')
            throw new Error('Sifariş tapılmadı')
        } catch (error) {
            console.error('❌ Get order error:', error.response?.data || error.message)
            return rejectWithValue(
                error.response?.data || { message: 'Order alına bilmədi' }
            )
        }
    }
)

export const orderReducer = createSlice({
    name: 'order',
    initialState: {
        myOrders: [],
        myDigitalOrders: [],
        sellerOrders: [], // ✅ YENİ - Seller orders
        totalSellerOrders: 0, // ✅ YENİ
        errorMessage: '',
        successMessage: '',
        myOrder: {},
        orderLoading: false,
        orderDetailLoading: false,
        orderDetailError: ''
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ''
            state.successMessage = ''
            state.orderDetailError = ''
        },
        updateOrderDeliveryConfirmed: (state, { payload }) => {
            const orderId = payload.orderId
            const patch = {
                delivery_status: payload.delivery_status || 'Təsdiqləndi',
                deliveryStatus: payload.deliveryStatus || 'confirmed',
                isConfirmed: payload.isConfirmed ?? true,
                confirmedAt: payload.confirmedAt,
                sellerBalanceCredited: payload.sellerBalanceCredited ?? true,
                updatedAt: payload.updatedAt || new Date().toISOString()
            }

            state.myOrders = state.myOrders.map(order =>
                order._id === orderId ? { ...order, ...patch } : order
            )

            if (state.myOrder?._id === orderId) {
                state.myOrder = { ...state.myOrder, ...patch }
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_orders.pending, (state) => {
                state.orderLoading = true;
                state.errorMessage = '';
            })
            .addCase(get_orders.fulfilled, (state, { payload }) => {
                state.myOrders = Array.isArray(payload?.orders) ? payload.orders : [];
                state.orderLoading = false;
                state.errorMessage = '';
            })
            // ✅ Rəsmi digital sifarişlər
            .addCase(get_my_digital_orders.fulfilled, (state, { payload }) => {
                state.myDigitalOrders = Array.isArray(payload?.orders) ? payload.orders : [];
            })
            .addCase(get_my_digital_orders.rejected, (state) => {
                state.myDigitalOrders = [];
            })
            // ✅ YENİ - Seller orders
            .addCase(get_seller_orders.fulfilled, (state, { payload }) => {
                state.sellerOrders = payload.orders;
                state.totalSellerOrders = payload.totalOrder;
            })
            .addCase(get_order.pending, (state) => {
                state.myOrder = {};
                state.orderDetailLoading = true;
                state.orderDetailError = '';
            })
            .addCase(get_order.fulfilled, (state, { payload }) => {
                // Handle both { order } and direct order object
                state.myOrder = payload.order || payload;
                state.orderDetailLoading = false;
                state.orderDetailError = '';
            })
            .addCase(get_orders.rejected, (state, action) => {
                state.myOrders = [];
                state.orderLoading = false;
                state.errorMessage = 'Siparişler alınamadı.';
            })
            // ✅ YENİ - Seller orders error
            .addCase(get_seller_orders.rejected, (state, action) => {
                state.errorMessage = 'Seller siparişleri alınamadı.';
            })
            .addCase(get_order.rejected, (state, action) => {
                state.myOrder = {};
                state.orderDetailLoading = false;
                state.orderDetailError = action.payload?.message || 'Sipariş detayları alınamadı.';
                state.errorMessage = 'Sipariş detayları alınamadı.';
            });
    }

})

export const {
    messageClear,
    updateOrderDeliveryConfirmed
} = orderReducer.actions
export default orderReducer.reducer
